import React, { Component } from "react";
import { Menu, Icon, Layout } from "antd";
import Logo from "../assets/img/Logo.png";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
const { Sider } = Layout;

class Model extends Component {
  state = {
    config: [
      {
        name: "新闻管理",
        link: "/admin/news",
        icon: "pie-chart"
      },
      {
        name: "职位管理",
        link: "/admin/jobs",
        icon: "solution"
      },
      {
        name: "公司信息",
        link: "/admin/companyInfo",
        icon: "trophy"
      },
      {
        name: "技术文档",
        link: "/admin/document",
        icon: "file-pdf"
      },
      {
        name: "图片管理",
        link: "/admin/addImg",
        icon: "picture"
      },
      {
        name: "事项管理",
        link: "/admin/matters",
        icon: "database"
      },
      {
        name: "留言信息",
        link: "/admin/messages",
        icon: "message"
      },
    ]
  };
  render() {
    return (
      <Sider
        trigger={null}
        collapsible
        collapsed={this.props.collapsed}
        breakpoint="md"
        width={260}
      >
        <div className="logo">
          <img src={Logo} alt="logo" />
          <h1>北京智充科技</h1>
        </div>
        <Menu
          theme="dark"
          onSelect={this.selected}
          selectedKeys={[`${this.props.ActiveNum}`]}
          mode="inline"
        >
          {this.state.config.map((item, index) => {
            return (
              <Menu.Item key={`${index}`}>
                <Link to={item.link}>
                  <Icon type={item.icon} />
                  <span>{item.name}</span>
                </Link>
              </Menu.Item>
            );
          })}
        </Menu>
      </Sider>
    );
  }
}

export default connect(state => ({
  collapsed: state.Global.collapsed,
  ActiveNum: state.Global.sliderActive
}))(Model);



// WEBPACK FOOTER //
// ./src/components/Slider.jsx